// product.js — product page behaviour (gallery, variants, quantity, reviews-by-colour).
// Extracted from sections/main-product.liquid inline blocks; reads its data from the
// #js-product-data JSON block that stays in the section.

(function () {
  function $(id) { return document.getElementById(id); }
  var byId = $('js-product-data');
  var DATA = { colourIndex: -1, variants: [] };
  try { DATA = JSON.parse(byId.textContent); } catch (e) { /* leave defaults */ }

  var VARIANTS = DATA.variants || [];
  var COLOUR_INDEX = (typeof DATA.colourIndex === 'number') ? DATA.colourIndex : -1;

  var form = $('product-form');
  var mainImg = $('main-product-img');
  var thumbs = [].slice.call(document.querySelectorAll('.product-gallery__thumb'));
  var swatches = form ? [].slice.call(form.querySelectorAll('.variant-swatch')) : [];

  // --- Flash-free image swapping (2026-09-23) ---------------------------------------------------
  // The old swap faded the main photo to opacity 0 (.is-swapping), waited for a plain 1000px copy,
  // then dropped the srcset and showed that — a blank frame on every colour click, and a URL that
  // never matched what the srcset had already cached (600/832px). Colour changes also un-hid lazy
  // thumbs/slides that had never loaded, so the new colour's photos appeared as empty boxes.
  // Now: the main <img> keeps the SAME srcset/sizes it was rendered with (so the browser picks the
  // same, already-cached width), a detached copy loads + decode()s first, and only then is the real
  // node's srcset/src switched in one go — the old photo stays on screen until the new one is ready.
  var DESK_MQ = window.matchMedia ? window.matchMedia('(min-width: 768px)') : null;
  function isDesk() { return !!(DESK_MQ && DESK_MQ.matches); }
  var MAIN_W = [360, 600, 832, 1000], MAIN_SIZES = '(min-width: 768px) 600px, 1px';   // = main-product.liquid
  function absUrl(u) { try { return new URL(u, location.href).href; } catch (e) { return u; } }
  function mainSet(u) {   // Shopify image_url: "…/x.jpg?v=123&width=1000" → the same 4-width srcset the section renders
    if (!/[?&]width=\d+/.test(u)) return '';
    return MAIN_W.map(function (w) { return u.replace(/([?&])width=\d+/, '$1width=' + w) + ' ' + w + 'w'; }).join(', ');
  }
  // Resolves once img has loaded AND decoded (or failed / timed out) — never rejects.
  function ready(img, ms) {
    return new Promise(function (res) {
      var fin = function (ok) { if (fin.d) return; fin.d = 1; if (ok === true) img._jOk = 1; res(); };
      if (!img) return fin();
      setTimeout(fin, ms || 5000);
      if (img.decode) img.decode().then(function () { fin(true); }, function () { fin(); });
      else if (img.complete) fin(true);
      else { img.addEventListener('load', function () { fin(true); }); img.addEventListener('error', function () { fin(); }); }
    });
  }
  // Give a deferred/lazy gallery <img> its real URLs and let it load now (same node, same srcset →
  // the same cached file is shown later). Undoes the speed-work data-src/data-srcset deferral early.
  function wake(img) {
    if (!img) return img;
    if (img.hasAttribute('data-srcset')) { img.srcset = img.getAttribute('data-srcset'); img.removeAttribute('data-srcset'); }
    if (img.hasAttribute('data-src')) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    if (img.loading === 'lazy') img.loading = 'eager';
    return img;
  }
  var warmed = {};
  function warmMain(src, hi) {   // detached copy with the main image's srcset/sizes → warms exactly the URL it will use
    var k = absUrl(src); if (warmed[k]) return warmed[k];
    var im = new Image(), set = mainSet(src);
    im.decoding = 'async'; im.fetchPriority = hi ? 'high' : 'low';   // a pick jumps ahead of background warming
    if (set) { im.sizes = MAIN_SIZES; im.srcset = set; }
    im.src = src; warmed[k] = im;
    return im;
  }
  var mainCur = mainImg ? absUrl(mainImg.getAttribute('src') || '') : '', mainTok = 0;
  function showMain(src) {
    if (!mainImg || !src) return;
    // data-thumb / variant.image are protocol-relative ("//jshop.ie/cdn/..."); compare absolute to absolute.
    var abs = absUrl(src);
    if (abs === mainCur) { mainTok++; return; }   // already showing it (also cancels a pending swap)
    var tok = ++mainTok, set = mainSet(src);
    var apply = function () {
      if (tok !== mainTok) return;   // a newer pick won
      mainCur = abs;
      if (set) { mainImg.sizes = MAIN_SIZES; mainImg.srcset = set; } else { mainImg.removeAttribute('srcset'); }
      mainImg.src = src;
    };
    // Phone: the main <img> is display:none and its <picture> hands it a 1x1 GIF — nothing to fetch or wait for.
    if (!isDesk()) return apply();
    var pre = warmMain(src, true);
    if (pre._jOk) return apply();   // already decoded → swap this frame
    ready(pre).then(apply);         // keep the current photo until the new one is decoded
  }
  function setActive(thumb) {
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    if (thumb) thumb.classList.add('is-active');
    paintCount();
  }
  // Photo counter chip ("3/8") on the desktop main photo and the phone carousel (2026-10-02). The active
  // thumb is the photo on screen in both layouts (phones: syncPhoneThumbs follows the carousel).
  var pgCounts = [].slice.call(document.querySelectorAll('[data-pg-count]'));
  function paintCount() {
    if (!pgCounts || !pgCounts.length) return;
    var vis = visibleThumbs(), n = vis.length, i = 0;
    for (var k = 0; k < n; k++) { if (vis[k].classList.contains('is-active')) { i = k; break; } }
    pgCounts.forEach(function (c) {
      c.hidden = n < 2;
      var cur = c.querySelector('[data-pg-cur]'), tot = c.querySelector('[data-pg-total]');
      if (cur) cur.textContent = i + 1; if (tot) tot.textContent = n;
    });
  }

  // --- Always-on basics: thumbnail clicks + quantity stepper. These attach
  // first and independently, so they keep working even if variant logic fails. ---
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () { setActive(t); showMain(t.dataset.thumb); });
  });

  // --- Gallery navigation: prev/next arrows, arrow keys, click-to-zoom ---
  function visibleThumbs() { return thumbs.filter(function (t) { return t.style.display !== 'none'; }); }
  function activeThumb() { return thumbs.filter(function (t) { return t.classList.contains('is-active'); })[0] || visibleThumbs()[0] || null; }
  // Step through the visible images; returns the new active thumb element.
  function galleryGo(delta) {
    var vis = visibleThumbs(); if (vis.length < 2) return null;
    var idx = 0;
    for (var i = 0; i < vis.length; i++) { if (vis[i].classList.contains('is-active')) { idx = i; break; } }
    idx = (idx + delta + vis.length) % vis.length;
    setActive(vis[idx]); showMain(vis[idx].dataset.thumb);
    return vis[idx];
  }
  var galPrev = document.querySelector('[data-gallery-prev]');
  var galNext = document.querySelector('[data-gallery-next]');
  if (galPrev) galPrev.addEventListener('click', function (e) { e.stopPropagation(); galleryGo(-1); });
  if (galNext) galNext.addEventListener('click', function (e) { e.stopPropagation(); galleryGo(1); });

  // --- Mobile swipe carousel: thumbnail row + variant image filtering (planShow/applyCarousel below) ---
  // Phones (2026-10-01): the dots were replaced by the thumbnail row (.product-gallery__thumbs, the same
  // buttons desktop uses, index i == slide i) — every photo when this variant has up to 14, a sideways
  // strip beyond that. Tapping a slide opens the full-screen photo viewer further down.
  var carousel = document.querySelector('[data-gallery-carousel]');
  var thumbsWrap = document.querySelector('[data-gallery-thumbs]');
  var slides = carousel ? [].slice.call(carousel.querySelectorAll('.product-gallery__slide')) : [];
  var visSlides = function () { return slides.filter(function (s) { return !s.hidden; }); };
  var PHONE_THUMBS_ALL = 14;
  // Re-label the visible slides/thumbs ("photo 3 of 9") and pick grid vs strip for the visible count.
  function labelGallery() {
    var vs = visSlides(), n = vs.length;
    vs.forEach(function (s, i) { s.setAttribute('aria-label', 'Photo ' + (i + 1) + ' of ' + n + ', open full screen'); });
    if (!thumbsWrap) return;
    var vt = visibleThumbs();
    thumbsWrap.classList.toggle('is-strip', vt.length > PHONE_THUMBS_ALL);
    thumbsWrap.classList.toggle('is-single', vt.length < 2);
    vt.forEach(function (t, i) { t.setAttribute('aria-label', 'Show photo ' + (i + 1) + ' of ' + vt.length); });
  }
  function centredSlide() {
    var vis = visSlides(); if (!vis.length || !carousel) return null;
    var cr = carousel.getBoundingClientRect(), cx = cr.left + cr.width / 2, best = vis[0], bestD = Infinity;
    vis.forEach(function (s) { var r = s.getBoundingClientRect(); var d = Math.abs((r.left + r.width / 2) - cx); if (d < bestD) { bestD = d; best = s; } });
    return best;
  }
  // Phone only: the thumb under the slide in view is the active one; a long strip keeps it in sight.
  function syncPhoneThumbs() {
    if (isDesk() || !carousel) return;
    var s = centredSlide(), t = s && thumbs[slides.indexOf(s)];
    if (!t || t.classList.contains('is-active')) return;
    setActive(t);
    if (thumbsWrap && thumbsWrap.classList.contains('is-strip')) {
      var wr = thumbsWrap.getBoundingClientRect(), tr = t.getBoundingClientRect();
      if (tr.left < wr.left || tr.right > wr.right) thumbsWrap.scrollTo({ left: thumbsWrap.scrollLeft + (tr.left - wr.left) - (wr.width - tr.width) / 2, behavior: 'smooth' });
    }
  }
  function scrollToSlide(s, smooth) {
    if (!carousel || !s) return;
    carousel.scrollTo({ left: carousel.scrollLeft + (s.getBoundingClientRect().left - carousel.getBoundingClientRect().left), behavior: smooth ? 'smooth' : 'auto' });
  }
  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { if (!isDesk() && slides[i] && !slides[i].hidden) scrollToSlide(slides[i], true); });
  });
  // blank alts render as the product title; manual admin uploads have free-text alts) is shared and
  // always shown. If none is tagged for this SKU, show everything rather than blank the gallery.
  function isAsinList(s) { return /^[A-Z0-9]{10}(\s+[A-Z0-9]{10})*$/.test((s || '').trim()); }
  function planShow(els, sku) {
    var uses = function (el) { return (el.dataset.asin || '').trim().split(/\s+/).indexOf(sku) !== -1; };
    var any = els.some(function (el) { return isAsinList(el.dataset.asin) && uses(el); });
    return els.map(function (el) { return !any || uses(el) || !isAsinList(el.dataset.asin); });
  }
  // Apply a slide plan; only touches the DOM (and resets scroll) when the visible set changes.
  function applyCarousel(show) {
    if (!slides.length) return;
    var changed = false;
    slides.forEach(function (s, i) { if (s.hidden === show[i]) { s.hidden = !show[i]; changed = true; } });
    if (!changed) return;
    if (carousel) carousel.scrollTo({ left: 0, behavior: 'auto' });
  }
  if (carousel) {
    labelGallery();
    var craf;
    carousel.addEventListener('scroll', function () { if (craf) cancelAnimationFrame(craf); craf = requestAnimationFrame(syncPhoneThumbs); }, { passive: true });
    slides.forEach(function (s) {
      s.setAttribute('role', 'button'); s.tabIndex = 0;
      s.addEventListener('click', function () { openViewer(s); });
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openViewer(s); } });
    });
  }

  // --- Phone photo viewer (2026-10-01) ---------------------------------------------------------------
  // Full screen, opened by tapping a carousel slide: swipe between this variant's photos, pinch or
  // double-tap to zoom (drag to look around), "3 / 9" counter, close with ✕, Esc, a swipe down or the
  // phone's Back button (a history entry, like the basket drawer). Photos load at the same 1600px as the
  // desktop lightbox (data-zoom), only for the open photo and its neighbours; the 800px carousel copy
  // already in the cache shows instantly underneath, so there is never a blank frame. Desktop keeps the
  // lightbox above (the carousel is display:none there, so this never opens on desktop).
  var pv = null;
  function openViewer(fromSlide) {
    if (pv || isDesk()) return;
    var list = visSlides(); if (!list.length) return;
    pv = photoViewer(list, Math.max(0, list.indexOf(fromSlide)), fromSlide);
  }
  window.addEventListener('popstate', function () { if (pv && pv.pushed) { pv.pushed = false; pv.teardown(); } });
  function photoViewer(list, start, opener) {
    var n = list.length, idx = start, W = window.innerWidth, H = window.innerHeight;
    var s = 1, tx = 0, ty = 0, g = null, lastTap = 0, lastTapP = null, MAX = 4;
    var title = (document.querySelector('.product-info__title') || {}).textContent || 'Product';
    var icon = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>'; };
    var root = document.createElement('div');
    root.className = 'pv'; root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.setAttribute('aria-label', 'Product photos');
    root.innerHTML = '<div class="pv__track"></div>' +
      '<div class="pv__bar"><span class="pv__count" aria-live="polite"></span><button type="button" class="pv__btn pv__close" aria-label="Close photos">' + icon('M6 6l12 12M18 6L6 18') + '</button></div>' +
      (n > 1 ? '<button type="button" class="pv__btn pv__nav pv__nav--prev" aria-label="Previous photo">' + icon('M15 18l-6-6 6-6') + '</button><button type="button" class="pv__btn pv__nav pv__nav--next" aria-label="Next photo">' + icon('M9 6l6 6-6 6') + '</button>' : '') +
      '<p class="pv__hint" aria-hidden="true">Pinch or double-tap to zoom</p>';
    var track = root.querySelector('.pv__track'), count = root.querySelector('.pv__count'), closeBtn = root.querySelector('.pv__close'),
        prevBtn = root.querySelector('.pv__nav--prev'), nextBtn = root.querySelector('.pv__nav--next');
    var cells = list.map(function (sl, i) {
      var cell = document.createElement('div'); cell.className = 'pv__slide';
      var im = document.createElement('img'); im.className = 'pv__img'; im.alt = title.trim() + ', photo ' + (i + 1) + ' of ' + n; im.decoding = 'async'; im.draggable = false;
      cell.appendChild(im); track.appendChild(cell);
      return { slide: sl, img: im, loaded: false };
    });
    function load(i) {
      var c = cells[i]; if (!c || c.loaded) return; c.loaded = true;
      var small = c.slide.querySelector('img'), big = c.slide.getAttribute('data-zoom');
      if (small && small.complete && small.naturalWidth > 1 && small.currentSrc) c.img.src = small.currentSrc;   // already cached
      if (!big) { if (!c.img.getAttribute('src') && small) c.img.src = small.getAttribute('data-src') || small.src; return; }
      if (!c.img.getAttribute('src')) { c.img.src = big; return; }
      var pre = new Image(); pre.decoding = 'async';
      pre.onload = function () { c.img.src = big; };
      pre.src = big;
    }
    function center() { return { x: W / 2, y: H / 2 }; }
    // Rendered photo size at scale 1 (object-fit: contain inside the W×H cell).
    function fit() {
      var im = cells[idx].img, nw = im.naturalWidth || W, nh = im.naturalHeight || W, r = Math.min(W / nw, H / nh);
      return { w: nw * r, h: nh * r };
    }
    function clampT() {
      var f = fit(), bx = Math.max(0, (f.w * s - W) / 2), by = Math.max(0, (f.h * s - H) / 2);
      tx = Math.max(-bx, Math.min(bx, tx)); ty = Math.max(-by, Math.min(by, ty));
    }
    function paint(anim) {
      var im = cells[idx].img;
      im.style.transition = anim ? 'transform .25s ease' : 'none';
      im.style.transform = 'translate3d(' + tx + 'px,' + ty + 'px,0) scale(' + s + ')';
      root.classList.toggle('is-zoomed', s > 1.01);
    }
    function zoomTo(ns, nx, ny, anim) { s = Math.max(1, Math.min(MAX, ns)); tx = nx; ty = ny; if (s <= 1.01) { s = 1; tx = 0; ty = 0; } clampT(); paint(anim); }
    function toggleZoom(p) {
      if (s > 1.01) return zoomTo(1, 0, 0, true);
      var c = center(), ns = 2.5;
      zoomTo(ns, (p.x - c.x) * (1 - ns), (p.y - c.y) * (1 - ns), true);
    }
    function moveTrack(dx, anim) {
      track.style.transition = anim ? 'transform .28s ease' : 'none';
      track.style.transform = 'translate3d(' + (-idx * W + dx) + 'px,0,0)';
    }
    function go(i, anim) {
      i = Math.max(0, Math.min(n - 1, i));
      if (i !== idx) { s = 1; tx = 0; ty = 0; paint(false); idx = i; }   // leaving a zoomed photo resets it
      paint(false);
      moveTrack(0, anim !== false);
      count.textContent = (idx + 1) + ' / ' + n;
      load(idx); load(idx + 1); load(idx - 1);
      if (prevBtn) prevBtn.disabled = idx === 0;
      if (nextBtn) nextBtn.disabled = idx === n - 1;
    }
    var pt = function (t) { return { x: t.clientX, y: t.clientY }; };
    var dist = function (a, b) { return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y)) || 1; };
    var mid = function (a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; };
    function startOne(p) { g = { mode: s > 1.01 ? 'pan' : '', p0: p, last: p, t: Date.now(), vx: 0, vy: 0, x0: tx, y0: ty, moved: false }; }
    track.addEventListener('touchstart', function (e) {
      var ts = e.touches;
      if (ts.length >= 2) {
        var a = pt(ts[0]), b = pt(ts[1]);
        if (g && g.mode === 'swipe') moveTrack(0, true);
        g = { mode: 'pinch', d0: dist(a, b), m0: mid(a, b), s0: s, x0: tx, y0: ty };
      } else if (ts.length === 1) startOne(pt(ts[0]));
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      if (!g) return;
      if (e.cancelable) e.preventDefault();
      var ts = e.touches;
      if (g.mode === 'pinch') {
        if (ts.length < 2) return;
        var a = pt(ts[0]), b = pt(ts[1]), m = mid(a, b), c = center();
        var ns = Math.max(0.8, Math.min(MAX * 1.15, g.s0 * dist(a, b) / g.d0)), k = ns / g.s0;
        s = ns; tx = (m.x - c.x) - (g.m0.x - c.x - g.x0) * k; ty = (m.y - c.y) - (g.m0.y - c.y - g.y0) * k;
        paint(false);
        return;
      }
      if (ts.length !== 1) return;
      var p = pt(ts[0]), now = Date.now(), dx = p.x - g.p0.x, dy = p.y - g.p0.y, dt = Math.max(1, now - g.t);
      g.vx = (p.x - g.last.x) / dt; g.vy = (p.y - g.last.y) / dt; g.last = p; g.t = now;
      if (Math.abs(dx) > 8 || Math.abs(dy) > 8) g.moved = true;
      if (!g.mode) {
        if (!g.moved) return;
        g.mode = Math.abs(dx) >= Math.abs(dy) ? 'swipe' : (dy > 0 ? 'down' : 'none');
      }
      if (g.mode === 'swipe') moveTrack(((idx === 0 && dx > 0) || (idx === n - 1 && dx < 0)) ? dx / 3 : dx, false);
      else if (g.mode === 'down') {
        var y = Math.max(0, dy), im = cells[idx].img;
        im.style.transition = 'none';
        im.style.transform = 'translate3d(0,' + y + 'px,0) scale(' + (1 - Math.min(0.2, y / (H * 2))) + ')';
        root.style.setProperty('--pv-fade', String(1 - Math.min(0.85, y / 320)));
      } else if (g.mode === 'pan') { tx = g.x0 + dx; ty = g.y0 + dy; clampT(); paint(false); }
    }, { passive: false });
    function endTouch(e) {
      if (!g) return;
      if (e.touches && e.touches.length === 1 && g.mode === 'pinch') { zoomTo(s, tx, ty, true); startOne(pt(e.touches[0])); g.moved = true; return; }
      if (e.touches && e.touches.length) return;
      var gg = g; g = null;
      if (gg.mode === 'pinch') return zoomTo(s, tx, ty, true);
      if (gg.mode === 'swipe') {
        var dx = gg.last.x - gg.p0.x;
        if ((dx < -W * 0.18 || gg.vx < -0.45) && dx < 0) return go(idx + 1);
        if ((dx > W * 0.18 || gg.vx > 0.45) && dx > 0) return go(idx - 1);
        return go(idx);
      }
      if (gg.mode === 'down') {
        var dy = gg.last.y - gg.p0.y;
        if (dy > 110 || gg.vy > 0.6) return close();
        root.style.removeProperty('--pv-fade'); paint(true);
        return;
      }
      if (gg.moved) return;   // a pan, already clamped
      // A tap: two within 300ms and 30px = double-tap zoom (in, or back out).
      var now = Date.now(), p = gg.last;
      if (lastTapP && now - lastTap < 300 && dist(p, lastTapP) < 30) { lastTap = 0; lastTapP = null; toggleZoom(p); }
      else { lastTap = now; lastTapP = p; }
    }
    track.addEventListener('touchend', endTouch);
    track.addEventListener('touchcancel', function (e) { if (g && g.mode === 'swipe') { g = null; go(idx); } else endTouch(e); });
    track.addEventListener('dblclick', function (e) { toggleZoom({ x: e.clientX, y: e.clientY }); });   // mouse / trackpad
    root.querySelectorAll('.pv__nav').forEach(function (b) {
      b.addEventListener('click', function () { go(idx + (b.classList.contains('pv__nav--prev') ? -1 : 1)); });
    });
    closeBtn.addEventListener('click', function () { close(); });
    root.addEventListener('keydown', function (e) {
      e.stopPropagation();   // the page's own arrow-key / Esc gallery handlers stay out of it
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      else if (e.key === 'Tab') {   // focus trap
        var f = [].filter.call(root.querySelectorAll('button'), function (b) { return b.offsetParent !== null && !b.disabled; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        else if (f.indexOf(document.activeElement) === -1) { e.preventDefault(); first.focus(); }
      }
    });
    function onResize() { W = window.innerWidth; H = window.innerHeight; s = 1; tx = 0; ty = 0; paint(false); moveTrack(0, false); }
    window.addEventListener('resize', onResize);
    var api = { pushed: false };
    var closing = false;
    api.teardown = function () {
      if (closing) return; closing = true;
      window.removeEventListener('resize', onResize);
      document.documentElement.classList.remove('pv-open');
      root.classList.remove('is-open');
      var back = list[idx];
      scrollToSlide(back, false); syncPhoneThumbs();   // the page shows the photo the shopper ended on
      setTimeout(function () { root.remove(); }, 200);
      pv = null;
      try { (back || opener).focus({ preventScroll: true }); } catch (e) {}
    };
    function close() { if (api.pushed) history.back(); else api.teardown(); }
    document.body.appendChild(root);
    document.documentElement.classList.add('pv-open');
    go(idx, false);
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    try { history.pushState({ jshopPv: 1 }, ''); api.pushed = true; } catch (e) {}
    closeBtn.focus({ preventScroll: true });
    setTimeout(function () { root.classList.add('hint-off'); }, 2600);
    return api;
  }

  // Preload the 1000px gallery images during idle so thumb-switching is INSTANT — DESKTOP ONLY
  // (mobile uses the carousel, which loads its own slides; pre-pulling ~1MB of 1000px + 1600px
  // images was the page's single biggest bandwidth drain and starved the LCP image). The 1600px
  // zoom versions are no longer prefetched at all — the lightbox loads them on demand at click.
  // Speed (2026-09-23): preload only the thumbs of the CURRENT variant (the visible ones), not all
  // of them — a many-colour product (e.g. 140 photos) pulled ~17MB of 1000px images on every desktop
  // view. update() re-runs this after a colour change, and hovering a colour swatch warms that
  // colour's photos first, so switching stays instant.
  // 2026-09-23: warms via warmMain (the main image's own srcset/sizes), so the width that loads here
  // is the one showMain will display — a cache hit, where the old plain-1000px warm missed on 1x screens.
  var preOn = false;
  function preloadThumb(t) { var u = t && t.dataset.thumb; if (u) warmMain(u); }
  function preloadVisible() { if (preOn) visibleThumbs().forEach(preloadThumb); }
  (function preload() {
    if (!window.matchMedia || !window.matchMedia('(min-width: 768px)').matches) return;
    function run() { preOn = true; preloadVisible(); }
    if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 2500 }); else setTimeout(run, 600);
  })();

  // Click the main image to zoom (lightbox, full-res) with its own prev/next + keys.
  var mainWrap = document.getElementById('product-main-image');
  var lb = null;
  function zoomSrc(t) { return (t && (t.dataset.zoom || t.dataset.thumb)) || null; }
  function openLightbox() {
    var at = activeThumb();
    var src = zoomSrc(at) || (function () { var im = mainWrap.querySelector('img'); return im && (im.currentSrc || im.src); })();
    if (!src) return;
    lb = document.createElement('div'); lb.className = 'img-lightbox';
    var big = new Image(); big.src = src; big.alt = ''; big.className = 'img-lightbox__img';
    lb.appendChild(big);
    function arrow(cls, label, d, path) {
      var b = document.createElement('button'); b.className = 'img-lightbox__nav ' + cls; b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
      b.addEventListener('click', function (e) { e.stopPropagation(); var t = galleryGo(d); if (t) big.src = zoomSrc(t); });
      return b;
    }
    if (visibleThumbs().length > 1) { lb.appendChild(arrow('img-lightbox__nav--prev', 'Previous image', -1, 'M15 18l-6-6 6-6')); lb.appendChild(arrow('img-lightbox__nav--next', 'Next image', 1, 'M9 6l6 6-6 6')); }
    lb.addEventListener('click', closeLightbox);
    document.body.appendChild(lb);
  }
  function closeLightbox() { if (lb) { lb.remove(); lb = null; } }
  if (mainWrap) {
    mainWrap.style.cursor = 'zoom-in';
    mainWrap.addEventListener('click', openLightbox);
  }

  // Arrow keys: navigate the lightbox if open, else the gallery (ignore when typing).
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLightbox(); return; }
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var ae = document.activeElement, tag = ae && ae.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
    var t = galleryGo(e.key === 'ArrowLeft' ? -1 : 1);
    if (t && lb) { var bi = lb.querySelector('.img-lightbox__img'); if (bi) bi.src = zoomSrc(t); }
  });
  var qty = $('quantity');
  function qtyMax() { return qty && qty.max ? (parseInt(qty.max, 10) || 99) : 99; }
  // available stock and QTY_LIST_CAP). #quantity (hidden) stays the source of truth so the
  // cart-aware stock cap below keeps working unchanged.
  var qtyWrap = document.querySelector('[data-qty]');
  var qtyTrigger = qtyWrap && qtyWrap.querySelector('[data-qty-trigger]');
  var qtyMenu = qtyWrap && qtyWrap.querySelector('[data-qty-menu]');
  var qtyLabel = qtyWrap && qtyWrap.querySelector('[data-qty-label]');
  var QTY_LIST_CAP = 10;
  function syncQty() { if (qtyLabel && qty) qtyLabel.textContent = Math.max(1, parseInt(qty.value, 10) || 1); }
  function setQty(n) { n = Math.max(1, Math.min(n, qtyMax())); if (qty) qty.value = n; syncQty(); }
  function buildQtyMenu() {
    if (!qtyMenu || !qty) return;
    var cap = Math.max(1, Math.min(qtyMax(), QTY_LIST_CAP));
    var cur = Math.max(1, Math.min(parseInt(qty.value, 10) || 1, cap));
    var h = '';
    for (var i = 1; i <= cap; i++) { h += '<li role="option" class="product-qty__opt' + (i === cur ? ' is-sel' : '') + '" data-qty-opt="' + i + '" aria-selected="' + (i === cur ? 'true' : 'false') + '">' + i + '</li>'; }
    qtyMenu.innerHTML = h;
    setQty(cur);
  }
  function closeQty() { if (qtyMenu) qtyMenu.hidden = true; if (qtyTrigger) qtyTrigger.setAttribute('aria-expanded', 'false'); }
  if (qtyTrigger && qtyMenu) {
    qtyTrigger.addEventListener('click', function () {
      if (qtyMenu.hidden) { buildQtyMenu(); qtyMenu.hidden = false; qtyTrigger.setAttribute('aria-expanded', 'true'); }
      else closeQty();
    });
    qtyMenu.addEventListener('click', function (e) { var o = e.target.closest('[data-qty-opt]'); if (!o) return; setQty(parseInt(o.getAttribute('data-qty-opt'), 10)); closeQty(); });
    document.addEventListener('click', function (e) { if (qtyWrap && !qtyWrap.contains(e.target)) closeQty(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQty(); });
  }
  syncQty();

  // --- Cart-aware stock guard: never let the basket exceed real stock, even
  // across repeat visits. Read the live cart, subtract what's already in it for
  // this variant from its available stock, and cap the qty input + Add button.
  // Fixes "add max, go back, add max again → over-stock in basket". ---
  var ATC_BTNS = [].slice.call(document.querySelectorAll('#js-atc, button[form="product-form"]'));
  var cartQty = {};
  function variantById(id) { for (var i = 0; i < VARIANTS.length; i++) { if (VARIANTS[i].id === id) return VARIANTS[i]; } return null; }
  function currentId() { var inp = form && form.querySelector('input[name="id"]'); return inp ? parseInt(inp.value, 10) : (VARIANTS[0] && VARIANTS[0].id); }
  function remainingFor(v) {
    if (!v) return 0;
    var hardCap = v.tracked && v.policy === 'deny';   // a real ceiling only when oversell is denied
    if (!hardCap) return 99;
    return Math.max(0, (v.inv || 0) - (cartQty[v.id] || 0));
  }
  function applyCartCap() {
    var v = variantById(currentId());
    if (!v) return;
    var hardCap = v.tracked && v.policy === 'deny';
    var rem = remainingFor(v);
    if (qty) { qty.max = Math.max(1, rem); if (+qty.value > rem) qty.value = Math.max(1, rem); syncQty(); }
    var maxed = v.available && hardCap && rem <= 0;
    ATC_BTNS.forEach(function (btn) {
      if (!btn) return;
      if (maxed) { btn.disabled = true; btn.dataset.maxed = '1'; if (btn.id === 'js-atc') btn.textContent = 'Max in basket'; }
      else if (btn.dataset.maxed) { btn.dataset.maxed = ''; btn.disabled = !v.available; if (btn.id === 'js-atc') btn.textContent = v.available ? 'Add to Basket' : 'Out of Stock'; }
    });
    if (maxed) { var note = $('js-stock'); if (note) { note.className = 'product-info__stock product-info__stock--low'; note.textContent = 'Maximum available already in your basket'; } }
  }
  function loadCart() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartQty = {}; (c.items || []).forEach(function (it) { cartQty[it.variant_id] = (cartQty[it.variant_id] || 0) + it.quantity; }); applyCartCap(); })
      .catch(function () {});
  }
  loadCart();
  window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); }); // back-button (bfcache)

  // Add to Basket via AJAX. This makes SHOPIFY the authority at the moment of
  // adding: it re-checks live stock and (with DENY policy) refuses to oversell —
  // closing the race where someone adds faster than /cart.js can load. On success
  // we go to the cart (same as the old native submit); on a stock rejection we
  // surface the reason and refresh the cap.
  var addBusy = false;
  function setAddError(msg) {
    var el = $('js-add-error');
    if (!el && form) {
      el = document.createElement('p'); el.id = 'js-add-error'; el.className = 'product-form__error'; el.setAttribute('role', 'alert');
      var actions = form.querySelector('.product-form__actions');
      if (actions && actions.parentNode) actions.parentNode.insertBefore(el, actions.nextSibling); else form.appendChild(el);
    }
    if (!el) return;
    if (msg) { el.textContent = msg; el.style.display = ''; } else { el.style.display = 'none'; }
  }
  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBusy) return;
    var v = variantById(currentId());
    if (!v) return;
    setAddError('');
    var want = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
    // Fast client-side pre-check when we already know the cart (instant feedback).
    if (v.tracked && v.policy === 'deny') {
      var rem = remainingFor(v);
      if (rem <= 0) { setAddError(v.inv <= 0 ? 'Sorry, this option is out of stock.' : 'You already have the maximum available in your basket.'); applyCartCap(); return; }
      if (want > rem) { want = rem; if (qty) qty.value = rem; }
    }
    addBusy = true;
    ATC_BTNS.forEach(function (b) { if (b) b.disabled = true; });
    var addItem = { id: v.id, quantity: want };
    // Carry the RRP through as a hidden line-item property (underscore prefix =
    // hidden from order confirmation / packing slip) so the cart drawer can show
    // the per-line saving — cart.js doesn't expose compare_at_price otherwise.
    if (v.compareCents && v.compareCents > v.priceCents) { addItem.properties = { _rrp: String(v.compareCents) }; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [addItem] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (err) { throw err; }); return r.json(); })
      .then(function () {
        addBusy = false;
        // Brief "✓ Added" success flash on the Add buttons.
        ATC_BTNS.forEach(function (b) { if (b) { b.disabled = !v.available; b.classList.add('is-added'); setTimeout(function () { b.classList.remove('is-added'); }, 1400); } });
        // Open the slide-out cart drawer; fall back to the cart page if it's absent.
        if (window.JSHOPCart && window.JSHOPCart.openWithCart) { window.JSHOPCart.openWithCart({ added: true }); }
        else { window.location.href = '/cart'; }
      })
      .catch(function (err) {
        addBusy = false;
        ATC_BTNS.forEach(function (b) { if (b) { b.disabled = !v.available; b.dataset.maxed = ''; } });
        setAddError((err && (err.description || err.message)) || 'Sorry, we don’t have that many in stock.');
        loadCart(); // re-sync the cap/buttons from the authoritative cart
      });
  });

  // No variants or no swatches → single-variant product; cart guard above still runs.
  if (!VARIANTS.length || !swatches.length) return;

  // Chosen value per option index (seeded from the pre-selected swatches).
  var chosen = [];
  swatches.forEach(function (b) { if (b.classList.contains('is-selected')) chosen[+b.dataset.optionIndex] = b.dataset.value; });

  function currentVariant() {
    return VARIANTS.filter(function (v) {
      return v.options.every(function (o, i) { return o === chosen[i]; });
    })[0] || null;
  }

  // Show only the selected variant's images, so BOTH colour and size swap the gallery (rules in
  // planShow above). 2026-09-23: the swap is staged — the new variant's main photo, first thumbs
  // (desktop) or first slide (phone) are loaded + decoded while the OLD gallery stays on screen, then
  // everything flips in one frame. Nothing is rebuilt: the same <img> nodes and srcsets are reused.
  var GAL_WAIT = 5000, THUMB_WAKE = 8, galTok = 0;
  function galleryPlan(v) {
    var tShow = planShow(thumbs, v.sku), first = null, match = null;
    thumbs.forEach(function (t, i) {
      if (!tShow[i]) return;
      if (!first) first = t;
      if (v.image && !match && t.dataset.thumb === v.image) match = t;
    });
    return { tShow: tShow, sShow: planShow(slides, v.sku), active: v.image ? match : first,
             main: v.image || (first && first.dataset.thumb) || null };
  }
  // Start loading what the plan needs to paint, main photo first (same nodes/URLs the swap will reveal).
  // Returns { main: detached main copy to wait on | null, rest: newly revealed thumbs / the slide that
  // will sit in the phone's frame }.
  function warmPlan(p) {
    var w = { main: null, rest: [] }, n = 0;
    if (isDesk()) {
      if (p.main && absUrl(p.main) !== mainCur) w.main = warmMain(p.main, true);
      thumbs.forEach(function (t, i) { if (p.tShow[i] && n < THUMB_WAKE) { n++; var im = wake(t.querySelector('img')); if (im && t.style.display === 'none') w.rest.push(im); } });
    } else {
      slides.forEach(function (s, i) {
        if (!p.sShow[i] || n >= 2) return;
        var im = wake(s.querySelector('img'));
        if (n++ === 0 && im && s.hidden) w.rest.push(im);
      });
    }
    return w;
  }
  function applyThumbs(p) {
    thumbs.forEach(function (t, i) { var d = p.tShow[i] ? '' : 'none'; if (t.style.display !== d) t.style.display = d; });
    setActive(p.active);
    labelGallery(); syncPhoneThumbs();   // phone: the thumb row follows the carousel, not the variant's main photo
    preloadVisible();   // desktop: warm the rest of this variant's photos (no-op until the idle preload has started)
  }
  // Two steps so the big photo never waits on the thumbnail strip: the main photo flips the moment it is
  // decoded, the thumbs (and the phone carousel) flip once their photos are in too. Until each step,
  // the previous colour's photos stay on screen — never an empty frame.
  function swapGallery(v, now) {
    var tok = ++galTok, p = galleryPlan(v);
    if (now) { applyCarousel(p.sShow); applyThumbs(p); if (p.main) showMain(p.main); return; }   // page load: no extra fetches racing the LCP photo
    var w = warmPlan(p), live = function () { return tok === galTok; };
    var mainP = (w.main ? ready(w.main, GAL_WAIT) : Promise.resolve()).then(function () { if (live() && p.main) showMain(p.main); });
    Promise.all([mainP].concat(w.rest.map(function (im) { return ready(im, GAL_WAIT); }))).then(function () {
      if (!live()) return;
      applyCarousel(p.sShow); applyThumbs(p);
    });
  }

  function markAvailability() {
    swatches.forEach(function (b) {
      var idx = +b.dataset.optionIndex;
      var ok = VARIANTS.some(function (v) {
        return v.available && v.options.every(function (o, i) {
          return i === idx ? o === b.dataset.value : (chosen[i] == null || o === chosen[i]);
        });
      });
      b.classList.toggle('is-unavailable', !ok);
      b.title = ok ? (b.classList.contains('variant-swatch--img') ? (b.dataset.value || '') : '') : 'Available in another colour/size. Click to see';
    });
  }

  // Float the AVAILABLE sizes to the top (in numeric order) and push the ones that
  // aren't stocked in the chosen colour below a divider — so the shopper instantly
  // sees what they can actually buy, and the list re-shuffles when they pick a colour.
  // Speed (2026-10-03): sections/main-product.liquid now prints the buttons already in this order, folded and priced,
  // so the page does not jump when this runs. On the first pass the sort reads only the size name (the price spans
  // used to be empty at that point; now the section has filled them), so the order is exactly as before.
  // The section's own toggle line is adopted below instead of adding a second one. Undo: drop `first` and the
  // two "adopt" lines.
  function reorderSizes(first) {
    document.querySelectorAll('.variant-option').forEach(function (grp) {
      var label = grp.querySelector('.variant-option__label');
      if (!label || label.textContent.toLowerCase().indexOf('size') === -1) return;
      var wrap = grp.querySelector('.variant-option__values'); if (!wrap) return;
      var btns = [].slice.call(wrap.querySelectorAll('.variant-swatch'));
      function num(b) { var m = (first ? (b.dataset.value || '') : b.textContent).replace(/,/g, '').match(/\d+/); return m ? +m[0] : -1; }
      var byNum = function (a, b) { return num(a) - num(b); };
      var avail = btns.filter(function (b) { return !b.classList.contains('is-unavailable'); }).sort(byNum);
      var gone = btns.filter(function (b) { return b.classList.contains('is-unavailable'); }).sort(byNum);
      var divider = wrap._sizeTog || wrap.querySelector('.variant-divider');
      // 2026-09-26: the unavailable sizes are folded away behind this one line ("+5 more sizes in
      // other colours ▾") instead of a block of 5–9 faded pills; tapping it shows/hides them.
      if (!divider) {
        var srvS = wrap.nextElementSibling; // adopt the section's printed toggle (speed 2026-10-03)
        divider = wrap._sizeTog = (srvS && srvS.classList.contains('variant-divider--sizes')) ? srvS : document.createElement('button'); divider.type = 'button'; divider.className = 'variant-divider variant-divider--toggle variant-divider--sizes';
        divider.addEventListener('click', function () { wrap.classList.toggle('show-unavail'); divider._paint && divider._paint(); });
      }
      avail.forEach(function (b) { wrap.appendChild(b); });
      if (gone.length && avail.length) {
        // Name THIS option (e.g. "Size") + the chosen colour, so the label reads
        // "Size not available in Beige" rather than the ambiguous "…in this colour".
        //
        // Read the name from the values wrapper's aria-label, NOT from label.textContent — the
        // label is "{{ option.name }}: <span>{{ option.selected_value }}</span>", so textContent
        // is "Size: Single (3')" and the divider rendered "Size: Single (3') not available in
        // Lavender Purple". That names the shopper's CURRENT pick as unavailable while the page
        // is simultaneously showing it in stock with an Add to Basket. It got worse once the
        // mattress depth joined the option ("Size: Single (3') · 16cm not available in …").
        var optName = (wrap.getAttribute('aria-label')
            || (label.textContent || '').split(':')[0]
            || 'Option').trim();
        var cidx = (DATA && DATA.colourIndex != null) ? DATA.colourIndex : -1;
        var cval = (cidx >= 0) ? chosen[cidx] : null;
        // one colour only (e.g. a mattress): "in other colours" pointed at colours that don't exist
        var ncol = cidx >= 0 ? VARIANTS.reduce(function (acc, v) { var o = v.options && v.options[cidx]; if (o != null && acc.indexOf(o) < 0) acc.push(o); return acc; }, []).length : 0;
        if (ncol <= 1) cval = null;
        var n = gone.length, noun = optName.toLowerCase().replace(/s$/, '') + (n === 1 ? '' : 's');
        divider._paint = function () {
          divider.textContent = wrap.classList.contains('show-unavail')
            ? (cval ? optName + ' not available in ' + cval : 'Sold out') + ' ▴'
            : '+' + n + (cval ? ' more ' + noun + ' in other colours' : ' ' + noun + ' sold out') + ' ▾';
          divider.setAttribute('aria-expanded', wrap.classList.contains('show-unavail') ? 'true' : 'false');
        };
        divider._paint();
        wrap.classList.add('has-unavail-toggle');
        if (divider.parentNode !== wrap.parentNode || divider.previousSibling !== wrap) wrap.parentNode.insertBefore(divider, wrap.nextSibling);
      } else { wrap.classList.remove('has-unavail-toggle'); if (divider.parentNode) divider.parentNode.removeChild(divider); }
      gone.forEach(function (b) { wrap.appendChild(b); });
    });
  }

  // Colours not sold in the chosen size (2026-09-27, Jack): faded photos of near-identical wood/white
  // finishes read as buyable. Fold them away behind one line under the row, same as sizes:
  // "+5 more colours in other sizes ▾" → "Not available in 120cm ▴". Original order is kept.
  function reorderColours() {
    document.querySelectorAll('.variant-option__values--swatches').forEach(function (wrap) {
      var btns = [].slice.call(wrap.querySelectorAll('.variant-swatch'));
      btns.forEach(function (b, i) { if (b._ord == null) b._ord = i; });
      btns.sort(function (a, b) { return a._ord - b._ord; });
      var avail = btns.filter(function (b) { return !b.classList.contains('is-unavailable'); });
      var gone = btns.filter(function (b) { return b.classList.contains('is-unavailable') && !b.classList.contains('is-selected'); });
      avail.concat(btns.filter(function (b) { return gone.indexOf(b) === -1 && avail.indexOf(b) === -1; })).concat(gone)
        .forEach(function (b) { wrap.appendChild(b); });
      var tog = wrap._colTog;
      if (!tog) {
        var srvC = wrap.nextElementSibling; // adopt the section's printed toggle (speed 2026-10-03)
        tog = wrap._colTog = (srvC && srvC.classList.contains('variant-divider--colours')) ? srvC : document.createElement('button'); tog.type = 'button'; tog.className = 'variant-divider variant-divider--toggle variant-divider--colours';
        tog.addEventListener('click', function () { wrap.classList.toggle('show-unavail'); tog._paint(); });
      }
      if (gone.length && avail.length) {
        var idx = btns.length ? +btns[0].dataset.optionIndex : -1;
        var others = chosen.filter(function (c, i) { return i !== idx && c != null; }).join(' / ');
        var n = gone.length;
        var noun = (wrap.getAttribute('aria-label') || 'Colour').trim().toLowerCase().replace(/s$/, '');
        var otherNames = [].slice.call(document.querySelectorAll('.variant-option__values')).filter(function (w) { return w !== wrap; })
          .map(function (w) { return (w.getAttribute('aria-label') || '').trim().toLowerCase(); }).filter(Boolean);
        var otherWord = otherNames.length === 1 ? otherNames[0].replace(/s$/, '') + 's' : 'options';
        tog._paint = function () {
          var open = wrap.classList.contains('show-unavail');
          tog.textContent = open ? 'Greyed out colours are not available in ' + (others || 'this size') + ' ▴'
                                 : '+' + n + ' more ' + noun + (n === 1 ? '' : 's') + ' in other ' + otherWord + ' ▾';
          tog.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        tog._paint();
        wrap.classList.add('has-unavail-toggle');
        if (tog.parentNode !== wrap.parentNode) wrap.parentNode.insertBefore(tog, wrap.nextSibling);
      } else {
        wrap.classList.remove('has-unavail-toggle', 'show-unavail');
        if (tog.parentNode) tog.parentNode.removeChild(tog);
      }
    });
  }

  // in the currently-chosen colour. Unavailable sizes show no price. Re-runs on every colour pick.
  function updateSizePrices() {
    swatches.forEach(function (b) {
      var priceEl = b.querySelector('[data-size-price]');
      if (!priceEl) return;   // only size pills carry this element
      var idx = +b.dataset.optionIndex;
      var m = VARIANTS.filter(function (v) {
        return v.available && v.options.every(function (o, i) {
          return i === idx ? o === b.dataset.value : (chosen[i] == null || o === chosen[i]);
        });
      }).sort(function (x, y) { return (x.priceCents || 0) - (y.priceCents || 0); })[0];
      priceEl.textContent = m ? m.price : '';
    });
  }

  // {specs:[{label,value}], bullets:[string]}). The section renders the initially selected variant's
  // facts into [data-vf-selected] at the end of the description; this rebuilds that block for the
  // variant now selected. No facts (null / both lists empty) → the block is emptied and hidden, so no
  // empty heading. The container only exists for families that have the metafield, so every other
  var vfBox = document.querySelector('[data-vf-selected]');
  var VF_LEAD = /^([A-Z][^:<>]{2,58}?:)(\s|$)/;   // same lead-in rule as the description formatter
  function renderFacts(v) {
    if (!vfBox) return;
    var f = v && v.facts, rows = [];
    if (f && typeof f === 'object') {
      (Array.isArray(f.specs) ? f.specs : []).forEach(function (s) {
        var l = s && String(s.label == null ? '' : s.label).trim(), val = s && String(s.value == null ? '' : s.value).trim();
        if (l && val) rows.push({ label: l, value: val });
      });
      (Array.isArray(f.bullets) ? f.bullets : []).forEach(function (b) {
        b = String(b == null ? '' : b).trim(); if (!b) return;
        b = b.replace(/^\s*【\s*([^】]+?)\s*】\s*/, '$1: ');
        var m = b.match(VF_LEAD);
        rows.push(m ? { lead: m[1], text: b.slice(m[1].length) } : { text: b });
      });
    }
    while (vfBox.firstChild) vfBox.removeChild(vfBox.firstChild);
    if (!rows.length) { vfBox.hidden = true; return; }
    var h = document.createElement('h3'), nm = document.createElement('span');
    nm.setAttribute('data-vf-name', ''); nm.textContent = (v.options || []).join(' / ');
    h.appendChild(document.createTextNode('Details for ')); h.appendChild(nm);
    var ul = document.createElement('ul'); ul.setAttribute('data-vf-list', '');
    rows.forEach(function (r) {
      var li = document.createElement('li');
      if (r.label != null) { var st = document.createElement('strong'); st.textContent = r.label + ':'; li.appendChild(st); li.appendChild(document.createTextNode(' ' + r.value)); }
      else if (r.lead) { var ld = document.createElement('strong'); ld.className = 'desc-lead'; ld.textContent = r.lead; li.appendChild(ld); li.appendChild(document.createTextNode(r.text)); }
      else li.textContent = r.text;
      ul.appendChild(li);
    });
    vfBox.appendChild(h); vfBox.appendChild(ul); vfBox.hidden = false;
  }

  function update(initial) {
    markAvailability();
    reorderSizes(initial === true);
    reorderColours();
    updateSizePrices();
    var atc = $('js-atc');
    var v = currentVariant();
    // No matching variant for this combo → block add-to-cart (prevents the
    // "Cannot find variant" cart error) and stop here.
    if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; } return; }
    if (form) { var idIn = form.querySelector('input[name="id"]'); if (idIn) idIn.value = v.id; }
    var price = $('js-price'), compare = $('js-compare'), sticky = $('js-sticky-price');
    if (price) price.textContent = v.price;
    if (sticky) sticky.textContent = v.price;
    var stickyOpt = $('js-sticky-variant');
    if (stickyOpt) {
      // Size first: the colour is already visible in the photo, so when the product also has a
      // size the bar names ONLY the size ("240 × 300 cm"); colour-only products show the colour.
      var opts = (v.options || []), nonColour = opts.filter(function (o, i) { return i !== COLOUR_INDEX && o && o !== 'Default Title'; });
      var lbl = (nonColour.length ? nonColour : opts.filter(function (o) { return o && o !== 'Default Title'; })).join(' \u00b7 ');
      stickyOpt.textContent = lbl; stickyOpt.hidden = !lbl;
    }
    if (compare) { if (v.hasCompare > 0) { compare.textContent = 'RRP ' + v.compare; compare.style.display = ''; } else { compare.style.display = 'none'; } }
    var save = $('js-save'); if (save) { if (v.hasCompare > 0 && v.savePct > 0) { save.textContent = 'Save ' + v.saveAmt; save.style.display = ''; } else { save.style.display = 'none'; } }
    // Per-variant delivery estimate: use the variant's eta override if it has one, else the
    // default 3–7 day window rendered server-side (data-eta-default).
    // Dashes in an override read as "to" (house style).
    // An override whose end date ("... Mon 4 Aug") is already past is stale: show the normal window (same rule as the section).
    var etaOk = function (s) {
      var m = String(s).match(/(\d{1,2})\s+([A-Za-z]{3})[A-Za-z]*\.?\s*$/); if (!m) return true;
      var mi = 'janfebmaraprmayjunjulaugsepoctnovdec'.indexOf(m[2].toLowerCase()); if (mi < 0 || mi % 3) return true;
      var age = Date.now() - new Date(new Date().getFullYear(), mi / 3, +m[1], 23, 59).getTime();
      return !(age > 864e5 && age < 180 * 864e5);
    };
    [].forEach.call(document.querySelectorAll('[data-eta]'), function (etaEl) {
      etaEl.textContent = (v.eta && etaOk(v.eta)) ? String(v.eta).replace(/\s[\u2013\u2014-]\s/g, ' to ') : (etaEl.getAttribute('data-eta-default') || etaEl.textContent);
    });
    var dl = document.querySelector('[data-delivery]'); if (dl) dl.hidden = !v.available;
    // Key-facts line by the buy box (size, height range, max load, material): per option when the family has
    // per-option facts (v.kf, built in the section); otherwise the server-rendered line stays as it is.
    var kfEl = document.querySelector('[data-keyfacts]');
    if (kfEl && typeof v.kf === 'string') { var kft = kfEl.querySelector('[data-keyfacts-text]'); if (kft) kft.textContent = v.kf; kfEl.hidden = !v.kf; }
    renderFacts(v);
    if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'Add to Basket' : 'Out of Stock'; }
    // Also reflect availability on the sticky mobile Add + express-checkout buttons (they aren't
    // #js-atc, so they stayed enabled on a sold-out variant and gave a nonsense "max in basket"
    // error on tap). applyCartCap() below overlays the in-basket cap on top of this.
    ATC_BTNS.forEach(function (b) { if (b && b.id !== 'js-atc') b.disabled = !v.available; });
    // Cap the quantity selector at the real available stock (for tracked,
    // deny-oversell variants) instead of a flat 10; show a low-stock note.
    if (qty) {
      var capped = (v.tracked && v.policy === 'deny');
      var max = capped ? Math.max(1, v.inv) : 99;
      qty.max = max;
      if (+qty.value > max) qty.value = max;
      var note = $('js-stock');
      if (note) {
        note.style.display = '';
        if (!v.available) { note.className = 'product-info__stock product-info__stock--out'; note.textContent = 'Out of stock'; }
        else if (capped && v.inv > 0 && v.inv <= 10) { note.className = 'product-info__stock product-info__stock--low'; note.textContent = 'Only ' + v.inv + ' left in stock.'; }
        else { note.className = 'product-info__stock product-info__stock--in'; note.textContent = 'In stock & available for delivery'; }
      }
    }
    // Gallery: this variant's photos. On load it applies at once (the section pre-filtered the markup
    // server-side, so this is normally a no-op); on a click the old photos stay up until the new are decoded.
    swapGallery(v, initial === true);
    // Lets the "Goes well with" row under the page follow the chosen size (product-recommendations).
    try { document.dispatchEvent(new CustomEvent('jshop:variant', { detail: { id: v.id, options: v.options } })); } catch (e) {}
    applyCartCap(); // reconcile qty cap + Add button with what's already in the basket
  }

  // What clicking swatch (idx, val) would select. If the value isn't available in the current combo,
  // auto-switch the OTHER options to a combination where it IS available — so every swatch is
  // reachable and the customer sees it's genuinely available (just elsewhere), instead of hitting
  // a dead "Unavailable" state.
  function choiceFor(idx, val) {
    var c = chosen.slice(); c[idx] = val;
    var combo = VARIANTS.filter(function (v) { return v.options.every(function (o, i) { return o === c[i]; }); })[0];
    if (!combo || !combo.available) {
      var alt = VARIANTS.filter(function (v) { return v.available && v.options[idx] === val; })[0]
             || VARIANTS.filter(function (v) { return v.options[idx] === val; })[0];
      if (alt) c = alt.options.slice();
    }
    return c;
  }

  // Hover (mouse) / touch-down (finger, ~100ms+ before the click fires): start loading the photos of
  // the exact variant this swatch would select, so the click-time swap is usually instant.
  function prewarm(btn) {
    if (btn.classList.contains('is-selected')) return;
    var c = choiceFor(+btn.dataset.optionIndex, btn.dataset.value);
    var v = VARIANTS.filter(function (x) { return x.options.every(function (o, i) { return o === c[i]; }); })[0];
    if (!v) return;
    var p = galleryPlan(v), w = warmPlan(p);
    // desktop, after idle: the rest of that colour's photos — once its main photo is in, so they don't slow it
    if (preOn) ready(w.main, GAL_WAIT).then(function () { thumbs.forEach(function (t, i) { if (p.tShow[i]) preloadThumb(t); }); });
  }
  swatches.forEach(function (btn) {
    // hover waits for the hero photo so it never competes with LCP; a press always warms
    btn.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && (!mainImg || mainImg.complete)) prewarm(btn); });
    btn.addEventListener('pointerdown', function () { prewarm(btn); });
  });

  swatches.forEach(function (btn) {
    btn.addEventListener('click', function () {
      chosen = choiceFor(+btn.dataset.optionIndex, btn.dataset.value);
      // Reflect chosen[] across every swatch group.
      swatches.forEach(function (b) {
        var bi = +b.dataset.optionIndex;
        var on = b.dataset.value === chosen[bi];
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      // Keep each option label showing the chosen value ("Colour: Rustic Brown").
      document.querySelectorAll('[data-selected-for]').forEach(function (el) {
        var oi = +el.dataset.selectedFor; if (chosen[oi] != null) el.textContent = chosen[oi];
      });
      update();
    });
  });

  update(true); // initialise on load (also performs the size ordering via reorderSizes)
})();

// Mobile sticky buy-bar (2026-09-25): shown whenever the real Add button is OFF screen — below the
// fold on first load as well as after scrolling past it — so "Add to Basket" is on the first phone
// screen (it used to sit 1,200–1,900px down). Hidden while the real button itself is visible, so
// there are never two. The bar names the selected option (see update()).
(function () {
  var bar = document.querySelector('.product-sticky-bar');
  var atc = document.getElementById('js-atc');
  if (!bar || !atc) return;
  // Measured directly (on load, scroll, resize) rather than only by IntersectionObserver, which
  // some browsers pause in background/hidden tabs — the bar must never be missing.
  function check() {
    var r = atc.getBoundingClientRect();
    var off = r.bottom < 0 || r.top > (window.innerHeight || document.documentElement.clientHeight);
    bar.classList.toggle('is-shown', off);
  }
  check();
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  window.addEventListener('load', check);
  if ('IntersectionObserver' in window) new IntersectionObserver(check, { threshold: 0 }).observe(atc);
})();

// Per-colour reviews: swap the rating, count and review cards as the shopper changes
// product-level reviews for any colour without its own captured set.
(function () {
  var dataEl = document.querySelector('[data-reviews-by-colour]'); if (!dataEl) return;
  var MAP; try { MAP = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }
  if (!MAP || !Object.keys(MAP).length) return;
  var BANNED = ('broke,broken,damaged,faulty,fault,crack,snapped,defect,fell apart,flimsy,cheap,poor quality,low quality,bad quality,missing,returned,refund,replacement,disappoint,not as described,wrong item,wrong size,waste,dont buy,don’t buy,do not buy,avoid,rubbish,terrible,awful,scam,smaller than,too small,bang for your buck,better value,more for your money,local option,buy local,look elsewhere,alternative,amazon,ebay,aliexpress,.co.uk').split(',');
  var BLOCK = (dataEl.getAttribute('data-review-block') || '').trim();   // quote vetted out by hand (jshop.buy_review_block)
  function clean(r) { if (!r || (r.stars || 0) < 4) return false; if (BLOCK && String(r.title || '').trim() === BLOCK) return false; var t = ((r.title || '') + ' ' + (r.body || '')).toLowerCase(); for (var i = 0; i < BANNED.length; i++) { if (t.indexOf(BANNED[i]) >= 0) return false; } return true; }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
  var ratingWrap = document.querySelector('[data-rating]');
  var fill = ratingWrap && ratingWrap.querySelector('[data-rating-fill]');
  var numEl = ratingWrap && ratingWrap.querySelector('[data-rating-num]');
  var cntEl = ratingWrap && ratingWrap.querySelector('[data-rating-count]');
  var agg = document.querySelector('[data-amz-agg]'), grid = document.querySelector('[data-amz-grid]');
  // 2026-10-03: the rating line shows the real count (thousands separated); the reviews list keeps every review the
  // page rendered (product + all colours, capped at the section's data-rv-cap) and moves the chosen colour's own
  // reviews to the top instead of replacing the list with that colour's few.
  var sec = document.getElementById('reviews');
  var CAP = sec ? (parseInt(sec.getAttribute('data-rv-cap') || '0', 10) || 25) : 25;
  var shownEl = sec && sec.querySelector('[data-amz-shown]'), basisEl = sec && sec.querySelector('[data-amz-basis]');
  function cntTxt(n) { n = Math.round(+n || 0); return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }   // 2,318 (round 1: no "30+" cap)
  var def = { num: numEl && numEl.textContent, cnt: cntEl && cntEl.textContent, fill: fill && fill.style.width, agg: agg && agg.innerHTML, grid: grid && grid.innerHTML, basis: basisEl && basisEl.textContent };
  function keyOf(r) { return String(r.title || '').trim() + '|' + String(r.author || '').trim(); }
  function card(r) {
    var aname = r.author; if (!aname || /amazon|kindle|\bprime\b|\bvine\b|\bviner\b/i.test(aname)) aname = 'Verified Customer';
    var imgs = (r.images && r.images.length) ? '<div class="amz-review__imgs">' + r.images.slice(0, 4).map(function (u) { var amz = /media-amazon\.com\/images\/I\/[^.\/]+\.jpg$/.test(u); var th = amz ? u.replace(/\.jpg$/, '._SL300_.jpg') : u; /* Speed (2026-10-03): 96px thumbnails, 1x screens take Amazon's 200px size, 2x+ keep 300px. Undo: drop the srcset part. */ var ss = amz ? ' srcset="' + esc(u.replace(/\.jpg$/, '._SL200_.jpg')) + ' 1x, ' + esc(th) + ' 2x"' : ''; return '<img class="amz-review__img" src="' + esc(th) + '"' + ss + ' data-full="' + esc(u) + '" alt="" loading="lazy" width="96" height="96" referrerpolicy="no-referrer">'; }).join('') + '</div>' : '';
    var avatar = r.avatar ? '<img class="amz-review__avatar" src="' + esc(r.avatar) + '" alt="" loading="lazy" width="36" height="36" referrerpolicy="no-referrer">' : '<span class="amz-review__avatar amz-review__avatar--ph" aria-hidden="true">' + esc((aname || '?').charAt(0).toUpperCase()) + '</span>';
    return '<article class="amz-review"><div class="amz-review__top">' + avatar +
      '<div class="amz-review__meta"><span class="stars stars--sm"><span class="stars__on" style="width:' + ((r.stars || 5) * 20) + '%"></span></span>' +
      '<span class="amz-review__author">' + esc(aname) + '</span></div></div>' +
      (r.title ? '<p class="amz-review__title">' + esc(r.title) + '</p>' : '') +
      (r.body ? '<p class="amz-review__body">' + esc(r.body) + '</p>' : '') + imgs + '</article>';
  }
  function apply(colour) {
    var d = colour && MAP[colour];
    var revs = d && d.reviews ? d.reviews.filter(clean) : [];
    // restore the server-rendered defaults first (rating, count, list order)
    if (numEl && def.num != null) numEl.textContent = def.num;
    if (cntEl && def.cnt != null) cntEl.textContent = def.cnt;
    if (fill && def.fill != null) fill.style.width = def.fill;
    if (agg && def.agg != null) agg.innerHTML = def.agg;
    if (grid && def.grid != null) grid.innerHTML = def.grid;
    if (basisEl && def.basis != null) basisEl.textContent = def.basis;
    if (!revs.length) { if (shownEl && grid) shownEl.textContent = grid.children.length; return; }
    revs.sort(function (a, b) { return (b.images ? b.images.length : 0) - (a.images ? a.images.length : 0); });
    var rating = d.rating ? (+d.rating).toFixed(1) : def.num;
    if (numEl) numEl.textContent = rating;
    if (fill && d.rating) fill.style.width = ((+d.rating) * 20) + '%';
    if (cntEl && d.count) cntEl.textContent = (+d.count === 1) ? '1 rating' : cntTxt(d.count) + ' ratings';
    if (basisEl && d.count) basisEl.textContent = cntTxt(d.count);
    if (agg && d.rating) { var suff = d.rating >= 4.5 ? ' · Excellent' : (d.rating >= 4.0 ? ' · Great' : ''); agg.innerHTML = '<span class="stars"><span class="stars__on" style="width:' + ((+d.rating) * 20) + '%"></span></span> <strong>' + rating + '</strong> out of 5' + suff; }
    if (grid) {
      var nodes = [].slice.call(grid.children), byKey = {};
      nodes.forEach(function (n) { byKey[n.getAttribute('data-k') || ''] = n; });
      for (var i = revs.length - 1; i >= 0; i--) {   // this colour's own reviews first, in their order
        var n = byKey[keyOf(revs[i])];
        if (!n) { var t = document.createElement('div'); t.innerHTML = card(revs[i]); n = t.firstChild; n.setAttribute('data-k', keyOf(revs[i])); }
        grid.insertBefore(n, grid.firstChild);
      }
      // 2026-10-04 (Jack: photos first, everywhere): reviews with photos above the rest; within each group the order
      // above stays (this colour's own first, then the page's most-helpful order). Undo: drop these two lines.
      var all = [].slice.call(grid.children), withImg = all.filter(function (n) { return n.querySelector('.amz-review__imgs'); });
      withImg.concat(all.filter(function (n) { return withImg.indexOf(n) < 0; })).forEach(function (n) { grid.appendChild(n); });
      while (grid.children.length > CAP) grid.removeChild(grid.lastChild);
      if (shownEl) shownEl.textContent = grid.children.length;
    }
  }
  function chosenColour() {
    var grp = [].slice.call(document.querySelectorAll('.variant-option')).filter(function (g) { var l = g.querySelector('.variant-option__label'); return l && /colou?r/i.test(l.textContent); })[0];
    if (!grp) return null;
    var sel = grp.querySelector('.variant-swatch.is-selected');
    return sel ? sel.dataset.value : null;
  }
  document.addEventListener('click', function (e) { if (e.target.closest('.variant-swatch')) setTimeout(function () { apply(chosenColour()); }, 0); });
  apply(chosenColour());
})();
